import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const accountdatatableInit = {
  accountdatatables: {},
  isLoadingAccountDataTables: false,
  availableAccountDataTableSlugs: {},
  chartsMissingDataTables: {},
};

function accountdatatablesReducer(draft, { type, payload }) {
  switch (type) {
    case "setAccountDataTables": {
      let newState = {}
      if (payload.DataTables.length) {
        payload.DataTables.forEach(dt => {
          newState[[dt.id]] = dt
        })
      }
      draft.accountdatatables = newState
      break;
    }
    case "updateAccountDataTables": {
        draft.accountdatatables[payload.id] = payload;
      break;
    }
    case "setIsLoadingAccountDataTables": {
      draft.isLoadingAccountDataTables = payload;
      
      break;
    }
    case "setAvailableAccountDataTables": {
      draft.availableAccountDataTableSlugs = payload;
      break;
    }
    case "addAvailableAccountDataTables": {
      draft.availableAccountDataTableSlugs[payload] = true;
      break;
    }
    case "addChartMissingDataTables": {
      draft.chartsMissingDataTables[payload] = true;
      break;
    }
    case "clearChartsMissingDataTables": {
      draft.chartsMissingDataTables = {};
      break;
    }
    default: {
      return null;
    }
  }
}

const [AccountDataTableContext, AccountDataTableDispatchContext] = [
  createContext(null),
  createContext(null),
];

export default function AccountDataTableProvider({ init, children }) {
  const [accountdatatableStore, dispatch] = useImmerReducer(
    accountdatatablesReducer,
    init || accountdatatableInit
  );

  return (
    <AccountDataTableContext.Provider value={accountdatatableStore}>
      <AccountDataTableDispatchContext.Provider value={dispatch}>
        {children}
      </AccountDataTableDispatchContext.Provider>
    </AccountDataTableContext.Provider>
  );
}

export function useAccountDataTableStore() {
  return useContext(AccountDataTableContext);
}

export function useAccountDataTableDispatch() {
  return useContext(AccountDataTableDispatchContext);
}
